module.exports = __webpack_public_path__ + "static/img/swiper01.99db969.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swiper01.jpg
// module id = 157
// module chunks = 1